import { render, staticRenderFns } from "./AddCustomViews.vue?vue&type=template&id=6463909c&"
import script from "./AddCustomViews.vue?vue&type=script&lang=js&"
export * from "./AddCustomViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports